module.exports = __webpack_public_path__ + "static/media/endorse_wdg.9275396f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/botrytis_fresa/preventiva/endorse_wdg.png
// module id = 1544
// module chunks = 3